import React from "react"
import { Typography, Grid, Box } from "@material-ui/core"
import {
	ArrowForwardIos as RArrowIcon,
	AccessTime as ClockIcon,
	Person as PersonIcon
} from "@material-ui/icons"

import { Portlet, Divider } from "@/components"

import useStyles from "@/pages/Admin/GroupMessageBlast/GroupMessageBlastListItem/styles"

import { MessageBlastStatus } from "@/protocols/messageBlast"
import { fullDatetime } from "@/utils/time"

import { Link } from "react-router-dom"
import { renderMessageBlastStatusToMaterialChips } from "@/utils/messageBlast"

type GroupMessageBlastListItemProps = {
	title: string
	status: MessageBlastStatus
	createdAt: Date
	sentAt?: Date
	messageBlastId: number
	scheduleTime?: Date
	createdByUser?: {
		id: number
		name: string
	}
	executedByUser?: {
		id: number
		name: string
	}
}

const GroupMessageBlastListItem: React.FC<GroupMessageBlastListItemProps> = (props) => {
	const { title, status, sentAt, messageBlastId, scheduleTime, createdAt, createdByUser, executedByUser } = props

	const classes = useStyles()

	return (
		<Portlet
			elevation={1}
		>
			<Grid
				container
				alignItems="center"
				spacing={2}
				className={classes.listItem}
				wrap="nowrap"
			>
				<Grid item xs={4}>
					<Link to={`/admin/group-message-blast/${messageBlastId}`} style={{ textDecoration: "none", wordWrap: "break-word" }}>
						<Typography
							variant="h4"
							className={classes.listItemTitle}
						>
							{title}
						</Typography>
					</Link>
					<Divider orientation="horizontal" size={1}/>
					<Typography variant="body2">
						#{messageBlastId}
					</Typography>
				</Grid>

				<Grid
					item
					xs={3}
					direction="column"
					alignItems="flex-end"
					justifyContent="center"
				>
					<Box display="flex" alignItems="center" justifyContent="flex-end">
						{renderMessageBlastStatusToMaterialChips({
							createdAt: createdAt,
							statusDate: sentAt,
							schedule: {
								time: scheduleTime
							},
							status: status
						})}
					</Box>
				</Grid>

				<Grid
					item
					xs={4}
				>
					<Grid
						container
						spacing={1}
					>
						<Grid
							item
							xs={12}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="flex-start"
							>
								<Grid item>
									<Grid container>
										<ClockIcon className={classes.icons} />
									</Grid>
								</Grid>

								<Grid item>
									<Typography
										variant="body1"
										className={classes.listItemData}
									>
									Adicionado em: {createdAt ? fullDatetime(createdAt) : "-"}
									</Typography>
								</Grid>
							</Grid>
						</Grid>

						{(executedByUser?.id || createdByUser?.id) && (
							<Grid item xs={12}>
								<Grid container alignItems="center" justifyContent="flex-start">
									<Grid item>
										<Grid container>
											<PersonIcon className={classes.icons} />
										</Grid>
									</Grid>

									<Grid item>
										{executedByUser?.id ? (
											<Typography variant="body1" className={classes.listItemData}>
												Enviado por: {executedByUser.name}
											</Typography>
										) : (
											<Typography variant="body1" className={classes.listItemData}>
												Criado por: {createdByUser?.name}
											</Typography>
										)}
									</Grid>
								</Grid>
							</Grid>
						)}
					</Grid>
				</Grid>

				<Grid item xs="auto">
					<Link to={`/admin/group-message-blast/${messageBlastId}`} style={{ textDecoration: "none" }}>
						<Grid container className={classes.listItemIconButton} justifyContent="center" alignItems="center">
							<Grid item>
								<RArrowIcon className={classes.listItemIcon}/>
							</Grid>
						</Grid>
					</Link>
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default GroupMessageBlastListItem
